module.exports = __webpack_public_path__ + "static/media/signal-alt-2.f967c246.svg";